/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { createRef } from "react";
import Draggable from 'react-draggable';
import PropTypes from "prop-types";
import Swiper from 'swiper/swiper-bundle.min.js'
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";
import 'swiper/swiper.less';

class PipelineProductSwiper extends React.Component {
  constructor(props) {
    super(props);
    let clientWidth = 375;
    if (typeof window !== 'undefined') {
      clientWidth = window.document.body.clientWidth;
    }
    const screenRatio = (clientWidth) / 375;
    this.state = {
      activeIndex: 0,
      activeItem: {},
      dragMode: false
    }
    this.screenRatio = screenRatio;
    this.productSwiperRef = null;
    this.mySwiper = null;
    this.swiperRef = null;
    this.swiperPaginationRef = createRef();
    this.tagsPositionInterval = null;
    this.isIframe = utils.getParams('isIframe') == 1
  }

  componentDidMount() {
    // 轮播组件初始化
    this.mySwiper = new Swiper(this.swiperRef, {
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: true,
      pagination: {
        el: this.swiperPaginationRef.current,
        clickable: true,
      },
      autoplay: this.isIframe ? false : {
        disableOnInteraction: false,
        delay: 2000,
      },
      loop: true,
      allowTouchMove: true,
      simulateTouch: true,
      touchStartPreventDefault: false,
      on: {
        slideChange: (swiper) => {
          this.handleSlideChange(swiper);
          this.handleTagsPosition();
        }
      }
    });
    this.handleSlideChange({ realIndex: 0 });
    this.handleTagsPosition();

    if (typeof window !== 'undefined' && window.self !== window.top) {
      window.addEventListener('message', this.receivePostMessageFromEditor);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined' && window.self !== window.top) {
      window.removeEventListener('message', this.receivePostMessageFromEditor);
    }
    if (this.mySwiper) {
      this.mySwiper.destroy();
      this.mySwiper = null;
    }
    if (this.tagsPositionInterval) {
      clearTimeout(this.tagsPositionInterval);
      this.tagsPositionInterval = null;
    }
  }

  receivePostMessageFromEditor = (event) => {
    const data = event.data || {};
    const msgType = data.msgType;
    if (msgType === 'checkToBaseConfig') {
      this.setState({
        dragMode: false,
      })
    }
    if (msgType === 'componentSelect') {
      const currentComponent = data.currentComponent;
      if (!currentComponent) {
        return;
      }
      // 编辑器切换组件之后，根据postMessage返回id，确认是否当前组件来切换模式
      if (currentComponent.id && this.props.customAttributes["data-component-block"].indexOf(currentComponent.id) > -1) {
        this.setState({
          dragMode: true,
        });
        this.handleTagsPosition();
      } else {
        this.setState({
          dragMode: false,
        })
      }
    }
  }

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (utils.isShihuo() && item.link) {
      const options = {
        link: item.link,
        sort: index,
      };
      const convertUrl = utils.convertHref(item.link);
      utils.jumpToUrl(this.props.routeParams, convertUrl, item.link, options, -1, this.props, false); 
    }
  }

  handleSlideChange = (swiper) => {
    const itemList = this.props.config.itemList;
    const activeIndex = swiper.realIndex;
    const activeItem = itemList[activeIndex];
    this.setState({
      activeIndex,
      activeItem
    }, () => {
      if (!this.isIframe) {
        setTimeout(() => {
          this.productSwiperRef.querySelectorAll('.swiper-slide').forEach((item, index) => {
            if (item.classList.contains('swiper-slide-active')) {
              item.querySelector('.drag-editor-container').setAttribute('class', 'drag-editor-container show');
            } else {
              item.querySelector('.drag-editor-container').setAttribute('class', 'drag-editor-container hide');
            }
          });
        }, 0); 
      }
    });
  }

  slideClick = (clickIndex) => {
    this.setState({
      activeIndex: clickIndex,
    });
    if (clickIndex === this.state.activeIndex) {
      this.handleItemClick(clickIndex);
    }
  }

  transformPx = (num) => {
    // 对单位进行转换
    num = Number(num);
    if (isNaN(num)) {
      num = 0;
    }
    const realNum = Math.round(num * this.screenRatio);
    return realNum;
  }

  handleOnDrag = (event) => {
    event.stopPropagation();
    this.mySwiper.update({
      allowTouchMove: false
    });
  }

  handleDragEnd = (index, key, event, position) => {
    // 拖拽结束，将位置信息发送到编辑器
    event.stopPropagation();
    this.mySwiper.update({
      allowTouchMove: true
    });
    const id = this.state.activeItem.id;
    const data = {
      left: String(position.x),
      top: String(position.y),
    };
    this.updateDragItemMessage(data, index, key, id);
    this.handleTagsPosition();
  }

  updateDragItemMessage = (data, index, key, id) => {
    if (typeof window !== 'undefined' && window.parent) {
      try {
        window.parent.postMessage({
          componentId: this.props.customAttributes["data-component-id"],
          msgType: 'updateDrag',
          index,
          key,
          data,
          id
        }, '*');
      } catch(err) {
        console.log(err);
      }
    }
  }

  // 获取文字标签的文字
  getTagPosition = (value, key, length) => {
    let left = this.transformPx(value.left);
    let top = this.transformPx(value.top);

    if (length === 2) {
      key = key + 1;
    }

    switch (key) {
      case 0:
        if (left == 0) {
          left = -10;
        }
        if (top == 0) {
          top = 130;
        }
        break;
      case 1:
        if (left == 0) {
          left = 202;
        }
        if (top == 0) {
          top = 94;
        }
        break;
      case 2:
        if (left == 0) {
          left = 182;
        }
        if (top == 0) {
          top = 158;
        }
        break;
      default:
        break;
    }

    return {
      left,
      top
    }
  }

  // 字符串截取指定长度的字符
  truncateString(str = '', maxLength) {
    let truncatedString = '';
    let currentLength = 0;
    for (let i = 0; i < str.length; i++) {
      const currentChar = str.charAt(i);
  
      // 如果是中文字符，计数加2
      if (/[\u4e00-\u9fa5]/.test(currentChar)) {
        currentLength += 2;
      } else {
        // 非中文字符，计数加1
        currentLength++;
      }
  
      // 如果当前长度未超过最大长度，将字符添加到截断字符串中
      if (currentLength <= maxLength) {
        truncatedString += currentChar;
      } else {
        // 如果超过最大长度，结束循环
        break;
      }
    }
  
    return truncatedString;
  }

  handleTagsPosition = () => {
    clearTimeout(this.tagsPositionInterval);
    this.tagsPositionInterval = null;
    this.tagsPositionInterval = setTimeout(() => {
      let dragEditorRef = null;
      if (this.isIframe) {
        dragEditorRef = this.productSwiperRef.querySelector('.drag-editor-container.show');
      } else {
        dragEditorRef = this.productSwiperRef.querySelector('.swiper-slide-active').querySelector('.drag-editor-container');
      }
      if (dragEditorRef) {
        dragEditorRef.querySelectorAll('.item-tag').forEach(tagItem => {
          const dragEditorRect = dragEditorRef.getBoundingClientRect();
          const tagRect = tagItem.getBoundingClientRect();

          const dragEditorRectCenterX = dragEditorRect.left + dragEditorRect.width / 2;
          const tagRectCenterX = tagRect.left + tagRect.width / 2;

          if (tagRectCenterX < dragEditorRectCenterX) {
            tagItem.classList.remove('show-left-dot');
            tagItem.classList.add('show-right-dot');
          } else if (tagRectCenterX > dragEditorRectCenterX) {
            tagItem.classList.remove('show-right-dot');
            tagItem.classList.add('show-left-dot');
          } else {
            tagItem.classList.remove('show-left-dot', 'show-right-dot');
            tagItem.classList.add('show-not-dot');
          }
        });
      }
    }, 0)
  }

  rederSparePriceOneLineView (price) {
    let sparePrice = null
    if (price > 1000) {
      sparePrice = utils.priceConversion(price, 2);
    }
     if(sparePrice && sparePrice.list) {
      let sparePriceList = sparePrice.list
      this.renderPriceLength = sparePriceList[0].length + (sparePriceList[1] ? sparePriceList[1].length : 0)
      return (
        <div className="price" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
          <span 
          style={{
            fontSize: px2rem('11px'),
            marginBottom: px2rem('2px'),
          }}
          >¥</span>
          <span 
            style={{
              fontSize: px2rem('16px'),
              marginBottom: px2rem('4px'),
            }}
          >{sparePriceList[0]}</span>
          {
            sparePriceList[1] && (
              <span
                style={{
                  fontSize: px2rem('12px'),
                  marginBottom: px2rem('2px'),
                }}
              >.{sparePriceList[1]}</span>
          )}
          {
            sparePrice.unit && (
              <span
                style={{
                  fontSize: px2rem('11px'),
                  marginBottom: px2rem('2px')
                }}
              >{sparePrice.unit}</span>
            )}
        </div>
      )
     } else {
      this.renderPriceLength = 0
      return (
        <div className="price"><span>¥</span>{price}</div>
      )
     }
  }

  render() {
    const { navigatorBarTheme = "黑" } = this.props;
    const { baseConfig, itemList } = this.props.config;
    const { activeItem = {}, activeIndex, dragMode } = this.state;
    const titleColor = baseConfig.titleColor || (navigatorBarTheme == "黑" ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)');
    return (
      <div
        ref={ref => this.productSwiperRef = ref}
        className="pipeline-productSwiper"
        {...this.props['customAttributes']}
        style={{
          backgroundImage: `url(${utils.formatImgUrl(baseConfig.bgImg, this.props.webpSupport)})`,
        }}
      >
        <div className="swiper-container" ref={ref => this.swiperRef = ref}>
          <div className="swiper-wrapper">
            {itemList.map((item, index) => {
              return (
                <div className="swiper-slide" key={`slide-${index}`}>
                  <div className="product-detail">
                    <div className="product-img-wrap">
                      <img className="product-img" src={utils.formatImgUrl(item.goodsImg, this.props.webpSupport)} alt="" />
                    </div>
                    { 
                      itemList[activeIndex]
                        && itemList[activeIndex].tagImg
                          && <img src={ itemList[activeIndex].tagImg} alt="" className="tag-img" />
                    }
                  </div>
                  {
                    !this.isIframe && (
                      <div className={`drag-editor-container ${activeIndex === index ? 'show' : 'hide'}`} key={`slide-drag-editor-${index}`} onClick={this.handleItemClick.bind(this, activeItem, activeIndex)}>
                        {item.tagList && item.tagList.map((value, key) => {
                          const { left = 0, top = 0 } = this.getTagPosition(value, key, item.tagList.length);
                          return (
                            <div key={`value_${key}`} style={{width: '100%', height: '100%'}}>
                              <Draggable
                                disabled={!dragMode}
                                defaultPosition={{ x: Number(left), y: Number(top) }}
                                bounds="parent"
                                handle=".handle"
                                onDrag={(event) => this.handleOnDrag(event)}
                                onStop={this.handleDragEnd.bind(this, index, key)}
                              >
                                {dragMode ?
                                  (
                                    <div
                                      className="edit-drag-item"
                                      style={{
                                        zIndex: key + 100
                                      }}
                                    >
                                      <div className="handle"></div>
                                      <div className={`item-tag tag${key + (item.tagList.length !== 2 ? 1 : 2)}`}><span className="left-dot"></span>{value.text}<span className="right-dot"></span></div>
                                    </div>
                                  ) :
                                  (
                                    <div
                                      className="preview-drag-item"
                                      style={{
                                        zIndex: key + 100,
                                      }}
                                    >
                                      <div className={`item-tag tag${key + (item.tagList.length !== 2 ? 1 : 2)}`}><span className="left-dot"></span>{value.text}<span className="right-dot"></span></div>
                                    </div>
                                  )
                                }
                              </Draggable>
                            </div>
                          );
                        })}
                      </div>
                    )
                  }
                </div>
              );
            })}
          </div>
          <div 
            className={`product-info ${navigatorBarTheme === '黑' ? 'dark' : 'light'}`} 
            style={{
              color: titleColor,
              borderColor: titleColor
            }}
          >
            <p className="name">{this.truncateString(activeItem.title, 22)}</p>
            {
              !baseConfig.hidePriceModal
                && activeItem.price > 0
                  && this.rederSparePriceOneLineView(activeItem.price)
            }
            <svg t="1700563482095" className="more" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2285" width="16" height="16">
              <path d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m-35.2 247.232a48 48 0 0 0-63.04 4.288l-4.288 4.864a48 48 0 0 0 4.288 62.976L606.08 511.68 413.76 704l-4.288 4.928a48 48 0 0 0 72.192 62.912l226.24-226.24 4.352-4.928a48 48 0 0 0-4.352-62.976L481.664 251.52z" p-id="2286" fill={titleColor}></path>
            </svg>
          </div>
          <div className={`swiper-pagination ${navigatorBarTheme === '黑' ? 'dark' : 'light'}`} ref={this.swiperPaginationRef}></div>
          {/* 标签拖拽展示区域 */}
          {
            this.isIframe && itemList.map((item, index) => {
              return (
                <div className={`drag-editor-container ${activeIndex === index ? 'show' : 'hide'}`} key={`drag-editor-${index}`} onClick={this.handleItemClick.bind(this, activeItem, activeIndex)}>
                  {item.tagList && item.tagList.map((value, key) => {
                    const { left = 0, top = 0 } = this.getTagPosition(value, key, item.tagList.length);
                    return (
                      <div key={`value_${key}`} style={{width: '100%', height: '100%'}}>
                        <Draggable
                          disabled={!dragMode}
                          defaultPosition={{ x: Number(left), y: Number(top) }}
                          bounds="parent"
                          handle=".handle"
                          onDrag={(event) => this.handleOnDrag(event)}
                          onStop={this.handleDragEnd.bind(this, index, key)}
                        >
                          {dragMode ?
                            (
                              <div
                                className="edit-drag-item"
                                style={{
                                  zIndex: key + 100
                                }}
                              >
                                <div className="handle"></div>
                                <div className={`item-tag tag${key + (item.tagList.length !== 2 ? 1 : 2)}`}><span className="left-dot"></span>{value.text}<span className="right-dot"></span></div>
                              </div>
                            ) :
                            (
                              <div
                                className="preview-drag-item"
                                style={{
                                  zIndex: key + 100,
                                }}
                              >
                                <div className={`item-tag tag${key + (item.tagList.length !== 2 ? 1 : 2)}`}><span className="left-dot"></span>{value.text}<span className="right-dot"></span></div>
                              </div>
                            )
                          }
                        </Draggable>
                      </div>
                    );
                  })}
                </div>
              )
            })
          }
        </div>
      </div>
    );
  }
}

PipelineProductSwiper.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineProductSwiper };
export default PipelineProductSwiper;



// WEBPACK FOOTER //
// ./components/pipeline-productSwiper/index.js